export default "__VITE_ASSET__C_CI_VqC__"